import { walletAddressValidation } from "./../validations/wallet.address.validator";

export default (values, value, type) => walletAddressValidation(value, type);
